import CoverageCarousel from './CoverageCarousel';
import CustomClientError from '../../../errorhandling/CustomClientError';
import SelectComponent from '../../common/auto-suggestion-select/Select';
import { useCoverage } from './hooks';
import './coverage.scss';
import { useTranslation } from 'react-i18next';

const Coverage = () => {
  const {
    onChangeHandler,
    options,
    selectedValue,
    memberAccumulatedData,
    defaultNetworkForAll,
    activeMember,
    activeMemberIndex,
    skeletonLoader,
    isAPIFailed,
    isNotFound,
  } = useCoverage();

  const { t } = useTranslation();
  return isAPIFailed ? (
    <div className="px-0">
      {isNotFound ? (
        <CustomClientError
          ErrorHeading="No data found"
          ErrorMessage="No coverage history data found for current member "
          NoDataFound={true}
          CustomClasses="p-0"
        />
      ) : (
        <CustomClientError
          ErrorHeading="Something went wrong with request!"
          ErrorMessage="Server request failed. Please contact support team."
          CustomClasses="p-0"
        />
      )}
    </div>
  ) : (
    <>
      <div className="coverage-container">
        <div className="wrapper">
          <>
            <div className="dropdown-container d-flex align-items-center">
              <span
                className="font-weight-bold"
                aria-label={`Coverage Status For ${selectedValue?.label}`}
              >
                {t('member.dashboard.coverage.statusfor')}
              </span>
              <SelectComponent
                options={options}
                components={{ IndicatorSeparator: () => null }}
                inputClassName="best-match-filter height-32"
                value={selectedValue}
                onChange={onChangeHandler}
                isSearchable={false}
                id="coverageStatus"
                labelText="Dropdown Filter, Coverage Status"
              />
            </div>
            <CoverageCarousel
              activeMember={activeMember}
              memberAccumulatedData={memberAccumulatedData}
              defaultNetworkForAll={defaultNetworkForAll}
              skeletonLoader={skeletonLoader}
              activeMemberIndex={activeMemberIndex}
            />
          </>
        </div>
      </div>
    </>
  );
};
export default Coverage;
